import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { ModalPopupComponent, ConfirmModalPopupComponent } from '../ui-components/';

@NgModule({
    imports: [CommonModule, ReactiveFormsModule],
    declarations: [
        ModalPopupComponent,
        ConfirmModalPopupComponent
    ],
    exports: [
        ModalPopupComponent,
        ConfirmModalPopupComponent
    ]
})
export class ModalLibModule { }
